export enum OutsideEnrollmentAreaStatus {
        /// <summary>
        /// Nije obrađeno<br/>
        /// Na postupku upisa naznačeno da roditelj/skrbnik želi dijete upisati u školu izvan upisnog područja
        /// </summary>
        NotProcessed = 1,
        /// <summary>
        /// Sugeriran upis<br/>
        /// Škola izvan upisnog područja je sugerirala ima li mjesta za školskog obveznika u njihovoj školi ili ne
        /// </summary>
        SuggestedEnrollment,
        /// <summary>
        /// Donesena odluka (rješenje)<br/>
        /// UO/GU donio odluku o osnovnoj školi u koju će dijete biti upisano ili rješenje o upisu na kojem je odabrana škola u koju će dijete biti upisano
        /// </summary>
        Decision,
}